var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"footer"},[_c('div',[_c('div',{staticClass:"version-info"},[_vm._v(_vm._s(_vm.config.version))]),_c('div',{staticClass:"copyright text-center"},[_vm._v("© AS Zaļais Punkts")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }